import { DataHeader, DataSource, Layout, Tab, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommPerformanceData extends Layout {
    dataheaderMobileCommPerformanceData: DataHeader;
    sourceMobileCommPerformanceData: DataSource;
    tabCruise: Tab;
    tabFuel: Tab;
    tabGeneral: Tab;
    tabIdle: Tab;
    tabParams: Tab;
    tabRPM: Tab;
    tabSafety: Tab;
    tabSpeed: Tab;
    tabTrip: Tab;
    tabsetPerformanceData: Tabset;
    textboxDriverId: Textbox;
    textboxEndDate: Textbox;
    textboxExcessSpeed: Textbox;
    textboxLongIdleThresh: Textbox;
    textboxOverSpeed: Textbox;
    textboxRPMThresh: Textbox;
    textboxStartDate: Textbox;
    textboxUnitId: Textbox;
}
